module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Nottwil-c58030f97dd314d49b6441494c02856c.svg";